module.exports = __webpack_public_path__ + "static/media/lowpolyblack.3def378b.JPG";